import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { PATHS } from '../../routes/paths';
import { loginUserApi } from '../../api';
import ConfirmModal from '../../components/common/ConfirmModal';
import Header from '../../components/common/Header';

const LoginPage = () => {
  const [form, setForm] = useState({
    loginId: '',
    password: '',
  });
  const [errors, setErrors] = useState({
    loginId: '',
    password: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (_event, newValue) => {
    if (newValue === 1) {
      navigate(PATHS.register);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      loginId: '',
      password: '',
    };

    if (!form.loginId.trim()) {
      newErrors.loginId = '아이디를 입력해주세요.';
    }
    if (!form.password.trim()) {
      newErrors.password = '비밀번호를 입력해주세요.';
    }

    setErrors(newErrors);
    const hasError = Object.values(newErrors).some((msg) => msg);
    if (hasError) return;

    try {
      setSubmitting(true);
      const res = await loginUserApi({
        loginId: form.loginId.trim(),
        password: form.password,
      });

      const token = res?.data?.token;
      const user = res?.data?.user;

      if (token) {
        window.localStorage.setItem('accessToken', token);
      }
      if (user) {
        window.localStorage.setItem('currentUser', JSON.stringify(user));
      }

      setSuccessOpen(true);
    } catch (err) {
      const message = err.message || '로그인 중 오류가 발생했습니다.';
      setErrors({
        loginId: '',
        password: message,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleSuccessConfirm = () => {
    setSuccessOpen(false);
    const fromState = location.state?.from;
    let nextPath = PATHS.root;
    if (typeof fromState === 'string' && fromState) {
      nextPath = fromState;
    } else if (fromState && typeof fromState === 'object') {
      const pathname = fromState.pathname || '';
      const search = fromState.search || '';
      const hash = fromState.hash || '';
      const combined = `${pathname}${search}${hash}`;
      if (combined) {
        nextPath = combined;
      }
    }
    navigate(nextPath, { replace: true });
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            maxWidth: 430,
            mx: 'auto',
            bgcolor: 'white',
            minHeight: '100vh',
            borderRadius: 0,
            boxShadow: '0 0 20px rgba(0,0,0,0.06)',
            px: 2,
            position: 'relative',
          }}
        >
          <Header variant="simple" />

          <Typography
            variant="h6"
            sx={{ fontWeight: 600, textAlign: 'center', mb: 2 }}
          >
            로그인
          </Typography>

          <Tabs
            value={0}
            onChange={handleTabChange}
            centered
            textColor="primary"
            indicatorColor="primary"
            sx={{
              mb: 3,
              minHeight: 32,
              '& .MuiTab-root': {
                minHeight: 32,
                fontSize: 14,
              },
            }}
          >
            <Tab label="로그인" />
            <Tab label="회원가입" />
          </Tabs>

          <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              mt: 0.5,
            }}
          >
            <TextField
              label="아이디"
              variant="outlined"
              size="medium"
              fullWidth
              value={form.loginId}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  loginId: e.target.value,
                }))
              }
              error={Boolean(errors.loginId)}
              helperText={errors.loginId || ' '}
            />
            <TextField
              label="비밀번호"
              type="password"
              variant="outlined"
              size="medium"
              fullWidth
              value={form.password}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  password: e.target.value,
                }))
              }
              error={Boolean(errors.password)}
              helperText={errors.password || ' '}
            />

            <Button
              variant="contained"
              fullWidth
              sx={{
                mt: 0.5,
                py: 1.2,
                bgcolor: '#0d47a1',
                fontWeight: 600,
                '&:hover': {
                  bgcolor: '#0b3a81',
                },
              }}
              type="submit"
              disabled={submitting}
            >
              로그인
            </Button>
          </Box>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ display: 'block', mt: 1 }}
          >
            ※ 비밀번호 찾기는 관리자에게 문의해주세요.
          </Typography>
        </Box>
      </Box>

      <ConfirmModal
        open={successOpen}
        message="로그인이 되었습니다."
        onConfirm={handleSuccessConfirm}
      />
    </>
  );
};

export default LoginPage;